module.exports = __webpack_public_path__ + "static/img/10.e998978.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/4/1/zh/10.png
// module id = tQdv
// module chunks = 0